<template>
  <LayoutMinimal>
    <div id="casting">
        <section class="main">
          <div class="casting-box">
            <div class="form">
              <h1 class="title">
                {{$t('casting.title')}}
              </h1>
              <CastingForm/>
            </div>
          </div>
        </section>
    </div>
  </LayoutMinimal>
</template>

<script>
    import LayoutMinimal from '../layouts/LayoutMinimal';
    import CastingForm from "../components/CastingForm";

    export default {
      components: {
        CastingForm,
        LayoutMinimal,
      },
      data(){
        return {
        }
      },
      methods: {
      },
      computed: {
      },
    }
</script>

<style scoped lang="scss">
  @import '../styles/variables';
  @import '../styles/classes';

  #casting{
    background-color: $pallete_dark_color;
    display: flex;
    color: $pallete_clear_text_color;
    flex-direction: column;
    justify-content: center;
    max-width: 750px;

    section.main {
      justify-content: space-around;
      position: relative;
      margin: 0;

      .casting-box{
        display: flex;
        margin: 0 auto;
        padding: 1.5em;
        background-color: #e6e6e6;
        border-radius: 10px;
        background: linear-gradient(to bottom,#e6e6e6 0,#ccc 100%);
        margin-left: 1em;
        margin-right: 1em;

        @media(max-width: 450px){
          border-radius: 3px;
          margin-left: 0;
          margin-right: 0;
          padding: .5em;
          width: 95vw;
        }

        .form{
          min-width: 350px;
          padding: 1em;
          background-color: #000000;
          border-radius: 5px;
          //margin-right: 1.5em;

          .title{
            text-align: center;
            width: 100%;
            text-transform: uppercase;
            letter-spacing: 0;
            margin: 0 0 .5em 0;
          }

          @media(max-width: 500px){
            min-width: auto;
          }
        }

        @media(max-width: 800px) {
          flex-direction: column;

          .form{
            margin-right: 0;
            margin-bottom: 1.5em;
          }
        }
      }
    }
  }
</style>
